import { render, staticRenderFns } from "./ShowIntro.vue?vue&type=template&id=35ae0627"
import script from "./ShowIntro.vue?vue&type=script&lang=js"
export * from "./ShowIntro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports